import {
  addDays, addMonths, addWeeks, addYears, parseISO,
} from 'date-fns';

type PeriodUnit = 'day' | 'week' | 'month' | 'year';

export function addPeriodToIsoDate(
  iso8601Date: string,
  periodCount: number,
  periodUnit: PeriodUnit,
): Date | null {
  const date = parseISO(iso8601Date);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  switch (periodUnit) {
    case 'day':
      return addDays(date, periodCount);
    case 'week':
      return addWeeks(date, periodCount);
    case 'month':
      return addMonths(date, periodCount);
    case 'year':
      return addYears(date, periodCount);
    default:
      return date;
  }
}
